<template>
  <div class="site-header-component">
    <div class="inner">
      <div class="hamburger" @click.stop.prevent="toggleMenu"></div>
      <div class="form">
        <label>Join our newsletter</label>
        <subscribe css-class="underlined" placeholder="Enter email here" />
      </div>
      <transition name="fade">
        <router-link to="/">
          <img src="../assets/logo.svg" class="logo desktop" v-if="displayLogo"/>
          <img src="../assets/logo.svg" class="logo mobile"/>
        </router-link>
      </transition>
      <social-links size="small" class="social"/>
    </div>
  </div>
</template>
<script>
  import SocialLinks from '@/components/SocialLinks.vue'
  import Subscribe from '@/components/Subscribe.vue'

  export default {
    name: 'site-header-component',
    components: { SocialLinks, Subscribe },
    props: ['toggleMenu'],
    data() {
      return {
        displayLogo: false,
      }
    },
    mounted() {
      window.addEventListener('scroll', this.setDisplayLogo)
    },
    destroyed() {
      window.removeEventListener('scroll', this.setDisplayLogo)
    },
    methods: {
      setDisplayLogo() {
        this.displayLogo = window.scrollY > 75
      },
    },
  }
</script>
<style scoped lang="scss">
  .site-header-component {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    height: 40px;
    background: #fff;
    z-index: 100;
    text-align: center;
  }
  .form {
    position: absolute;
    left: 10px;
    top: 10px;
    color: #bbb;
    font-size: 13px;
    > * {
      display: inline-block;
    }
    label {
      text-transform: uppercase;
      padding-right: 10px;
    }
  }
  .logo {
    width: 125px;
    margin-top: 3px;
    &.mobile {
      display: none;
    }
  }
  .social {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .hamburger {
    display: none;
  }
  @media (max-width: 500px) {
    .site-header-component {
      background: rgba(255, 255, 255, 0.8);
    }
    .form, .social {
      display: none;
    }
    .logo {
      &.desktop {
        display: none;
      }
      &.mobile {
        display: inline;
      }
    }
    .hamburger {
      display: block;
      position: absolute;
      left: 10px;
      top: 12px;
      width: 25px;
      height: 5px;
      border-top: 2px solid #888;
      border-bottom: 2px solid #888;
      &:before {
        content: "";
        position: absolute;
        top: 12px;
        left: 0px;
        width: 100%;
        border-top: 2px solid #888;
      }
    }
  }
</style>